import React from 'react'
import { NoResults } from 'src/components/PageLayout/NoResults'
import { Grid } from 'src/components/Reusable/Grid'
import { NoFilterResults } from 'src/components/PageLayout/NoFilterResults'
import { useAnalytics } from 'src/analytics/useAnalytics'
import { TableListLoader } from 'src/components/Reusable/ContentLoaders/TableListLoader'
import { AdvancedSearchOptions } from 'src/Utils/search/search.types'
import { AddRiskModalBtn } from '../risks.components'
import { NoRisksIcon, RiskGridContainer } from '../risks.styles'
import { RisksGridHeader } from '../grid/RisksGridHeader'
import { RiskGridRows } from '../grid/RisksGridRow'
import { RISK_GRID_TEMPLATE_COLUMNS } from '../risks.constants'

export const RiskGrid = ({ riskIds }: { riskIds: string[] }): JSX.Element => {
  return (
    <Grid pb="xs" gridTemplateColumns={RISK_GRID_TEMPLATE_COLUMNS}>
      <RisksGridHeader />
      <RiskGridRows riskIds={riskIds} />
    </Grid>
  )
}

export interface RisksIndexGridProps {
  searchQuery: string
  advancedSearchOptions: AdvancedSearchOptions | null
}

export const RisksIndexGrid = ({
  riskIds,
  isLoading,
  totalRisks,
}: {
  riskIds: string[]
  isLoading: boolean
  totalRisks: number
}): JSX.Element => {
  const { track, events } = useAnalytics()

  if (isLoading) {
    return <TableListLoader />
  }

  // Empty State if no risks present in account
  if (totalRisks === 0) {
    return (
      <RiskGridContainer>
        <NoResults
          icons={<NoRisksIcon />}
          title="Your Risk Register is empty."
          buttons={
            <AddRiskModalBtn
              text="Add Risk Scenarios"
              handleClick={() => track(events.C_ADD_MANUAL_RISK)}
            />
          }
          margin="16px 0"
        />
      </RiskGridContainer>
    )
  }

  return (
    <>
      {riskIds.length > 0 ? (
        <>
          <Grid
            pb="xs"
            gridTemplateColumns="repeat(2, min-content) minmax(auto, 30%) repeat(8, auto)"
          >
            <RisksGridHeader />
            <RiskGridRows riskIds={riskIds} />
          </Grid>
        </>
      ) : (
        <NoFilterResults />
      )}
    </>
  )
}
